import { css, useTheme } from '@emotion/react'
import React, { useState } from 'react'

function Accordion({ title, content }) {
    const [isActive, setIsActive] = useState(false)
    const theme = useTheme()
    const style = css`
        .accordion-title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0.30rem 0.5rem;
            background-color: ${theme.colors.transparent};
            border-radius: ${theme.borderRadius.default};
            color: ${theme.colors.primary};
        }
        .accordion-content {
            padding: 0.5rem;
            color: ${theme.colors.primary};
        }
    `
    return (
        <div className="accordion" css={style}>
            <div className="accordion-item">
                <div className="accordion-title outline outline-offset-4 outline-1" onClick={() => setIsActive(!isActive)}>
                    <div>{title}</div>
                    <div className="text-2xl">{isActive ? '-' : '+'}</div>
                </div>
                {isActive && <div className="accordion-content">{content}</div>}
            </div>
        </div>
    )
}

export default Accordion